/**
 * @file Comportement d'arme 'single' : Tir simple : 1 balle rectiligne, dispersion croissante en tir continu (SpreadAngleMin/Max/GrowthRate de l'original).
 */
import type { SimContext } from '../../Context';
import { applyDamage, rollCrit } from '../../combat/damage';
import type { With } from '../../ecs/World';
import { DEG } from '../../math/geometry';
import { spawnProjectile } from '../projectiles';
import type { HitOutcome, ShotContext, WeaponBehaviorModule } from '../WeaponBehavior';
import { announceShot } from './common';

/**
 * fire : angle = visee + aleatoire(+-spread/2) ; le cone croit a chaque tir jusqu'a weapon.spreadMaxDeg (reset par WeaponSystem
 * apres params.spreadResetSeconds sans tir). onHit : degats, balle consommee.
 */
export const singleBehavior: WeaponBehaviorModule = {
  id: 'single',
  fire(ctx: SimContext, shot: ShotContext): void {
    const { weapon: w, cat } = shot;
    const p = w.params;
    const angle = shot.aimAngle + ctx.rng.combat.range(-1, 1) * (cat.cat.spreadDeg / 2) * DEG;
    cat.cat.spreadDeg = Math.min(w.spreadMaxDeg, cat.cat.spreadDeg + p.spreadGrowthDegPerSec * w.interval);
    const roll = rollCrit(ctx, w, w.damage);
    const proj = spawnProjectile(ctx, {
      kind: 'bullet',
      behavior: 'single',
      ownerId: cat.id,
      weaponDefId: w.def.id,
      slot: w.slot,
      x: shot.originX,
      y: shot.originY,
      angle,
      speed: p.projectileSpeed,
      radius: p.projectileRadius,
      range: w.range,
      damage: roll.damage,
      crit: roll.crit,
      pierce: 0,
    });
    announceShot(ctx, shot, 'single', [proj.id]);
  },
  onHit(ctx: SimContext, proj: With<'projectile'>, target: With<'target' | 'health'>): HitOutcome {
    applyDamage(ctx, target, proj.projectile.damage, proj.projectile.crit, 'single', proj.transform.x, proj.transform.y);
    return { consumed: true };
  },
};
